import { Component, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { GetDiagnosticResults } from '../../../state/session/results.actions';
import { ViewJsonComponent } from '../view-json/view-json.component';
import { ReprocessDocument } from '../../../state/diagnostics/diagnostics.actions';
import { pluck } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { IDocumentResult } from '../../../state/interfaces';
import { MatCardTitle } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TABLE_BASE_COMMON_IMPORTS } from '../../material-base-common-imports';

@Component({
  selector: 'eca-app-document-results-table',
  templateUrl: './document-results-table.component.html',
  styleUrls: ['./document-results-table.component.css'],
  imports: [MatCardTitle, MatToolbar, MatFormField, MatInput, MatSort, MatButton, ThrottleClickDirective, MatTooltip, MatIcon, RouterLink, ...TABLE_BASE_COMMON_IMPORTS]
})
export class DocumentResultsTableComponent implements OnInit, OnDestroy {
  private _route = inject(ActivatedRoute);
  private _store = inject<Store<any>>(Store);
  private _dialog = inject(MatDialog);

  @Input() sessionId: string;

  config$: Subscription = new Subscription();
  documentResultColumnsToDisplay: string[] = ['userId', 'client', 'districtCode', 'schoolCode', 'testFamily',
    'materialId', 'lithocode', 'formId', 'status', 'error',
    'demographicResults', 'inputResults', 'scoringPayload', 'json',
    'debug', 'rescore'];

  documentResultsDataSource: MatTableDataSource<any>;
  JSON: any = JSON;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.sessionId = this._route.snapshot.params.sessionId;
    this._store.select('diagnostics').pipe(pluck('results')).subscribe((results) => {
      this.documentResultsDataSource = new MatTableDataSource(results[this.sessionId]);
      this.sort.direction = 'asc';
      this.sort.active = 'lithocode';
      this.documentResultsDataSource.sort = this.sort;
    });
    this._store.dispatch(new GetDiagnosticResults({sessionId: this.sessionId, populateAllFields: true}));
  }

  ngOnDestroy() {
    this.config$.unsubscribe();
  }

  openDialog(description: string, content: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      description,
      content,
    };

    this._dialog.open(ViewJsonComponent, dialogConfig);
  }

  doFilter(filterValue: string) {
    this.documentResultsDataSource.filter = filterValue.trim().toLowerCase();
  }

  debug(result: IDocumentResult) {
    this._store.dispatch(new ReprocessDocument({result, sessionId: this.sessionId, debug: true}));
  }

  reScore(result: IDocumentResult) {
    this._store.dispatch(new ReprocessDocument({result, sessionId: this.sessionId}));
  }
}
